import { lazy } from 'react'

/**
 * Módulo: Diagnóstico
 * Framework de evaluación empresarial: problemáticas, dimensiones, frameworks, criticidad.
 */
export default {
  id: 'diagnostico',
  nombre: 'Diagnóstico',
  descripcion: 'Framework de evaluación con problemáticas, dimensiones y motor de criticidad',
  icono: 'clipboard-check',
  tipo: 'estrategia',
  version: '1.0.0',
  // Solo consultores y admin configuran frameworks/dimensiones

  routes: [
    { path: 'frameworks', component: lazy(() => import('./pages/FrameworksPage')) },
    { path: 'frameworks/:id', component: lazy(() => import('./pages/FrameworkDetailPage')) },
    { path: 'dimensiones', component: lazy(() => import('./pages/DimensionesPage')) },
    { path: 'nivel-friccion', component: lazy(() => import('./pages/NivelFriccionPage')) },
    { path: 'estado-emocional', component: lazy(() => import('./pages/EstadoEmocionalPage')) },
    { path: 'horizonte-expectativa', component: lazy(() => import('./pages/HorizonteExpectativaPage')) },
    { path: 'objetivo-principal', component: lazy(() => import('./pages/ObjetivoPrincipalPage')) },
    { path: 'tamano-mercado', component: lazy(() => import('./pages/TamanoMercadoPage')) },
    { path: 'competencia', component: lazy(() => import('./pages/CompetenciaPage')) },
    { path: 'fortalezas', component: lazy(() => import('./pages/FortalezasPage')) },
    { path: 'debilidades', component: lazy(() => import('./pages/DebilidadesPage')) },
    { path: 'canales', component: lazy(() => import('./pages/CanalesPage')) },
    { path: 'base-patrones', component: lazy(() => import('./pages/BasePatronesPage')) },
    { path: 'estados-negocio', component: lazy(() => import('./pages/EstadosNegocioPage')) },
    { path: 'objetivos-ciclo', component: lazy(() => import('./pages/ObjetivosCicloPage')) },
    { path: 'motor-criticidad', component: lazy(() => import('./pages/CriticalityPage')) },
  ],

  menuItems: [
    // Movidos a Plataforma
  ],

  features: [
    'problematicas',
    'frameworks',
    'dimensiones',
    'criticidad',
    'capacidades-habilitantes',
  ],

  // permisoModulos (#58): se deriva del rol. menuItems está vacío (las páginas
  // de diagnóstico se linkean desde el grupo Plataforma) → no genera grupo propio.
  // Incluye el código de cada ítem del menú cuya ruta monta este módulo: lo exige `src/core/lib/menuRutaPermiso.guard.test.js`.
  permisoModulos: ['diagnostico', 'frameworks', 'dimensiones', 'motor-criticidad'],

}
